import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Bell, Zap, CheckCheck } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const { user } = useAuth();
  const nav = useNavigate();

  const load = () => api.get("/notifications").then((r) => setItems(r.data.notifications)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { try { await api.post(`/notifications/${id}/read`); load(); } catch { /* noop */ } };

  const renew = async () => {
    const plan_key = user?.plan && user.plan !== "free" ? user.plan : "premium_299";
    try {
      const r = await api.post("/payments/checkout", { plan_key, origin_url: window.location.origin });
      window.location.href = r.data.checkout_url;
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <div className="flex items-center gap-2 mb-6">
        <Bell className="w-6 h-6 text-[#6B1D2F]" />
        <h1 className="font-serif text-3xl font-semibold text-slate-900">Notifications</h1>
      </div>
      {items.length === 0 && <Card className="p-10 text-center border-[#EAE3D2] bg-white text-slate-600">You're all caught up.</Card>}
      <div className="space-y-3">
        {items.map((n) => (
          <Card key={n.id} className={`p-5 border-[#EAE3D2] bg-white flex items-start gap-3 ${!n.read ? "border-l-4 border-l-[#6B1D2F]" : ""}`} data-testid={`notification-${n.id}`}>
            <div className="flex-1">
              <p className="text-slate-800">{n.message}</p>
              <p className="text-xs text-slate-500 mt-1">{new Date(n.created_at).toLocaleString()}</p>
              <div className="flex gap-2 mt-3">
                {n.type === "plan_expiring" && (
                  <Button onClick={renew} data-testid={`renew-btn-${n.id}`} className="bg-[#D4AF37] hover:bg-[#B8860B] text-slate-900 font-semibold rounded-full">
                    <Zap className="w-4 h-4 mr-1" /> Renew now
                  </Button>
                )}
                {n.type === "interest_received" && <Button onClick={() => nav("/matches")} variant="outline" className="rounded-full">View match</Button>}
                {n.type === "interest_accepted" && <Button onClick={() => nav("/chat")} variant="outline" className="rounded-full">Open chat</Button>}
                {n.type === "verification_verified" && <Badge className="bg-emerald-50 text-emerald-800">Verified ✓</Badge>}
                {!n.read && <Button variant="ghost" size="sm" onClick={() => markRead(n.id)} data-testid={`read-${n.id}`}><CheckCheck className="w-4 h-4 mr-1" />Mark read</Button>}
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
